import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
interface ILookupTypeModalContext {
  data: any;
  title?: string;
  isEdit: boolean;
}
import { OptionTypeService } from '../../services';
@Component({
  selector: 'app-lookup-new-modal',
  templateUrl: './lookup-new-modal.component.html',
  styleUrls: ['./lookup-new-modal.component.scss'],
})
export class LookupTypeModalComponent implements OnInit, OnDestroy {
  searchable: boolean = true;
  public mode: DatepickerMode = 'year';
  public maxDate = new Date();
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pending: boolean;
  optionType;
  optionForm: FormGroup;
  isEdit;
  constructor(
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<ILookupTypeModalContext, void, void>,
    private optionTypeSvc: OptionTypeService
  ) {
    this.optionForm = fb.group({
      optionTypeId: ['', Validators.required],
      optionTypeName: [''],
    });
    this.isEdit = this.modal.context.isEdit;
    if (modal.context.isEdit) {
      this.optionForm.patchValue(modal.context.data);
    }
  }
  isFieldValid(field: string) {
    return (
      (!this.optionForm.get(field).valid &&
        this.optionForm.get(field).touched) ||
      (this.optionForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }
  submit() {
    this.isEdit == true ? this.update() : this.save();
  }
  save() {
    this.formSubmitAttempt = false;
    if (this.optionForm.valid) {
      this.pending = true;
      this.optionTypeSvc
        .addOptionTypes({ body: this.optionForm.value })
        .subscribe(
          (res) => {
            this.pending = false;
            this.success = 'Lookup Type added successfully';
            setTimeout(() => {
              this.modal.approve(null);
            }, 2000);
          },
          (error) => {
            this.pending = false;
            this.error = error.error.errorMessage ? error.error.errorMessage
                                                  : error.error ? error.error
                                                  : error;
          }
        );
    } else {
      this.formSubmitAttempt = true;
      this.pending = false;
      this.error = 'Please fill all required fields';
    }
  }

  update() {
    this.formSubmitAttempt = false;
    if (this.optionForm.valid) {
      this.pending = true;
      this.optionTypeSvc
        .updateOptionTypes({
          optionTypeId: this.modal.context.data.optionTypeId,
          body: this.optionForm.value,
        })
        .subscribe(
          (res) => {
            this.pending = false;
            this.success = 'Lookup Type added successfully';
            setTimeout(() => {
              this.modal.approve(null);
            }, 2000);
          },
          (error) => {
            this.pending = false;
            this.error = error.error.errorMessage ? error.error.errorMessage
                                                  : error.error ? error.error
                                                  : error;
          }
        );
    } else {
      this.formSubmitAttempt = true;
      this.pending = false;
      this.error = 'Please fill all required fields';
    }
  }
  nullify() {
    this.success = null;
    this.error = null;
  }
  ngOnInit() {
    // this.document.body.classList.remove('panel');
  }
  // s
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }
}

export class LookupTypeModal extends ComponentModalConfig<
  ILookupTypeModalContext,
  void,
  void
> {
  constructor(
    title: string,
    data: any,
    isEdit: boolean,
    size: ModalSize = ModalSize.Small
  ) {
    super(LookupTypeModalComponent, { title, data, isEdit });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
